// Ubicación en el repo: src/lib/holidays.js
// Feriados/cierres especiales (migración 0043, 23-ago-2026, ver
// DECISIONS.md) — lista GLOBAL de fechas bloqueadas para el
// auto-agendamiento público, con excepciones puntuales por sucursal (una
// sucursal que sí atiende ese día pese al cierre general). Administrado
// desde Configuración → Feriados y cierres (HolidaysSettings.jsx), solo
// Admin — RLS (`clinic_holidays_*`) ya lo exige del lado del servidor.
import { supabase } from './supabaseClient';

// Trae los feriados con sus excepciones ya resueltas como array de
// branch_id — más cómodo para el componente que anidar
// clinic_holiday_exceptions tal cual. Orden por fecha ascendente (el más
// próximo primero).
export async function listHolidays() {
  const { data, error } = await supabase
    .from('clinic_holidays')
    .select('id, date, label, clinic_holiday_exceptions(branch_id)')
    .order('date', { ascending: true });
  if (error) throw error;
  return (data ?? []).map((h) => ({
    id: h.id,
    date: h.date,
    label: h.label,
    exceptionBranchIds: (h.clinic_holiday_exceptions ?? []).map((e) => e.branch_id),
  }));
}

export async function createHoliday({ date, label }, actorId) {
  const { error } = await supabase
    .from('clinic_holidays')
    .insert({ date, label: label.trim(), created_by: actorId });
  if (error) throw error;
}

// Sin softDelete — mismo criterio explicado en la migración 0043: es lista
// de configuración pura, sin historial clínico/legal que preservar. El
// DELETE en cascada se lleva las excepciones de esa fecha con él.
export async function deleteHoliday(id) {
  const { error } = await supabase.from('clinic_holidays').delete().eq('id', id);
  if (error) throw error;
}

export async function addHolidayException(holidayId, branchId, actorId) {
  const { error } = await supabase
    .from('clinic_holiday_exceptions')
    .insert({ holiday_id: holidayId, branch_id: branchId, created_by: actorId });
  if (error) throw error;
}

export async function removeHolidayException(holidayId, branchId) {
  const { error } = await supabase
    .from('clinic_holiday_exceptions')
    .delete()
    .eq('holiday_id', holidayId)
    .eq('branch_id', branchId);
  if (error) throw error;
}
